import React from "react"
import { Grid } from "@mui/material"
import { ChevronLeft, ChevronRight } from "@mui/icons-material"
import moment from "moment"

import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import InfoIcon, { TooltipIconColor, TooltipType } from "components/InfoIcon"
import { teacherInfoIconBlock } from "components/InfoIcon/teacherInfoIcon"
import { TodoDetail } from "pages/assistant/components/TodoDetail"
import DateSelect from "components/DateSelect/temp3"
import { Loading } from "shared/components/ui/Loading"

import {
  renderBackgroundColorLXO,
  renderBackgroundColorLXO2,
} from "shared/utils/common"

import {
  noteTypography,
  titleTypography,
  descriptionTypography,
} from "shared/styles/style"
import { pagingItemStyle } from "admin/teacher/components/Table/style"
import NotFound from "assets/images/apollo-english/not-found.png"

const TodoListLXOMyTask = (props) => {
  const {
    classes,
    start,
    end,
    tabs,
    isOpenDetail,
    contentRef,
    list,
    filteredPages,
    tabIndex,
    isScrolling,
    currentPage,
    totalPage,
    setTabIndex,
    setOpenDetail,
    setSearchParams,
    searchParams,
    refetch,
    mobileMatches,
    setType = () => {},
    setDataDetail,
    dataDetail,
    isFetchingReport,
    handlerList,
    state,
  } = props

  const handleChangeDate = (key, value) => {
    const formatted = moment(value).format("MM-DD-YYYY")
    searchParams.set(key, formatted)

    key === "start"
      ? handlerList({ ...state, from: value })
      : handlerList({ ...state, to: value })
    setSearchParams(searchParams)
  }

  const handleChangeDateRange = (ranges) => {
    const startDate = ranges[0]
    const endDate = ranges[1]

    const formattedStart = moment(startDate).format("MM-DD-YYYY")
    const formattedEnd = moment(endDate).format("MM-DD-YYYY")

    searchParams.set("start", formattedStart)
    searchParams.set("end", formattedEnd)

    handlerList({ ...state, from: startDate, to: endDate })
    setSearchParams(searchParams)
  }

  const renderList = () => {
    if (isFetchingReport)
      return (
        <MDBox
          sx={({ breakpoints }) => ({
            width: "100%",
            height: 600,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            [breakpoints.down(1600)]: { height: 400 },
          })}
        >
          <Loading style={{ width: 300, height: 200 }} />
        </MDBox>
      )

    if (!list?.length)
      return (
        <MDBox
          component="img"
          src={NotFound}
          sx={({ breakpoints }) => ({
            width: "100%",
            height: 600,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            objectFit: "contain",
            [breakpoints.down(1600)]: { height: 400 },
          })}
        />
      )

    return list.map((item, index) => {
      const id = item.lxoId
      const deadline = item.toDate
      const status = item.taskStatus || "In progress"
      const type = item.taskType
      const description = item.taskDescription
      const title = item.task

      return (
        <MDBox
          key={index}
          id={"id" + id}
          sx={({ breakpoints, functions: { pxToRem } }) => ({
            padding: pxToRem(24),
            borderRadius: pxToRem(15),
            cursor: "pointer",
            background: "#FFFFFF",
            minWidth: "100%",
            [breakpoints.down(1600)]: {
              padding: pxToRem(14),
              borderRadius: pxToRem(8),
            },
          })}
          onClick={() => {
            setOpenDetail(true)
            setType(type)
            props.setReportId(id)
            setDataDetail(item)
          }}
        >
          {/* Header: Status + Deadline */}
          <MDBox
            display="flex"
            justifyContent="space-between"
            sx={({ breakpoints }) => ({
              flexDirection: "row",
              [breakpoints.down(768)]: { flexDirection: "column" },
            })}
          >
            <MDBox
              sx={({ functions: { pxToRem } }) => ({
                padding: `${pxToRem(4)} ${pxToRem(8)}`,
                borderRadius: pxToRem(6),
                marginBottom: pxToRem(8),
                width: "fit-content",
                background: renderBackgroundColorLXO2(status),
              })}
            >
              <MDTypography
                sx={({ breakpoints, typography }) => ({
                  fontFamily: typography.lexendFont,
                  fontSize: 12,
                  fontWeight: 400,
                  color: "#FFFFFF",
                  textTransform: "uppercase",
                  [breakpoints.down(1600)]: { fontSize: 9 },
                })}
              >
                {status}
              </MDTypography>
            </MDBox>

            {deadline && (
              <MDTypography
                sx={({ breakpoints }) => descriptionTypography(breakpoints)}
              >
                Due: {moment(deadline).format("MMM DD, YYYY")}
              </MDTypography>
            )}
          </MDBox>

          {/* Title */}
          <MDTypography
            sx={({ breakpoints, typography }) => ({
              ...titleTypography(breakpoints),
              display: "block",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              [breakpoints.down(1600)]: { fontSize: 13 },
            })}
          >
            {title}
          </MDTypography>

          {/* Info */}
          <MDTypography sx={({ breakpoints }) => noteTypography(breakpoints)}>
            Type: {type}
          </MDTypography>
        </MDBox>
      )
    })
  }

  return (
    <MDBox
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="center"
      sx={({ breakpoints, functions: { pxToRem } }) => ({
        borderRadius: pxToRem(16),
        background: "#fff",
        padding: `${pxToRem(24)}`,
        marginBottom: pxToRem(24),
        [breakpoints.down(1600)]: {
          rowGap: 2.5,
          flexDirection: "column",
          padding: pxToRem(18),
          borderRadius: pxToRem(8),
        },
        [breakpoints.down(1366)]: { rowGap: 2, padding: pxToRem(12) },
      })}
      className="assistant-todo-list"
    >
      {/* Header */}
      <MDBox
        display="flex"
        width="100%"
        alignItems="center"
        justifyContent="space-between"
        mb={3}
        gap={2}
        sx={({ breakpoints }) => ({
          mb: 3,
          [breakpoints.down(1600)]: { mb: 2 },
          [breakpoints.down("md")]: {
            flexDirection: "column",
            rowGap: "16px",
            alignItems: "flex-start",
          },
        })}
      >
        <MDBox
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          gap={{ xs: 2, md: 3 }}
          sx={({ breakpoints }) => ({
            [breakpoints.down("md")]: {
              justifyContent: "space-between!important",
              width: "100%",
            },
          })}
        >
          <InfoIcon
            type={TooltipType.TYPE_1}
            teacherInfoIconBlock={teacherInfoIconBlock.TODO_LIST}
            color={TooltipIconColor.BLUE}
            className={classes.containerInfoIconWithHeading}
          >
            <MDTypography
              sx={({ breakpoints, functions: { pxToRem } }) => ({
                ...titleTypography(breakpoints),
                lineHeight: 1.37,
                letterSpacing: "-0.8px",
                paddingLeft: "12px",
                [breakpoints.down(768)]: { minWidth: pxToRem(100) },
              })}
            >
              To Do List
            </MDTypography>
          </InfoIcon>

          <DateSelect
            // onChangeStartDate={(e) => handleChangeDate("start", e)}
            // onChangeEndDate={(e) => handleChangeDate("end", e)}
            onChangeDate={handleChangeDateRange}
            defaultStartDate={
              start ?? moment().startOf("isoweek").format("MM-DD-YYYY")
            }
            defaultEndDate={
              end ?? moment().endOf("isoweek").format("MM-DD-YYYY")
            }
          />
        </MDBox>

        <Grid
          container
          alignItems="center"
          sx={({ breakpoints, functions: { pxToRem } }) => ({
            borderRadius: pxToRem(12),
            padding: pxToRem(4),
            background: "#F6F9FC",
            maxWidth: "100%",
            gap: "6px",
            width: "fit-content",
            [breakpoints.down("md")]: { alignSelf: "center" },
          })}
        >
          {tabs.map((item, index) => (
            <Grid
              key={index}
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap={1}
              sx={({ breakpoints, functions: { pxToRem } }) => ({
                height: pxToRem(35),
                borderRadius: pxToRem(8),
                background: tabIndex === index ? "white" : "inherit",
                boxShadow:
                  tabIndex === index ? "0px 2px 6px 0px #00000040" : "unset",
                cursor: "pointer",
                padding: `${pxToRem(0)} ${pxToRem(24)}`,
                [breakpoints.down(768)]: { width: "calc(50% - 6px)" },
              })}
              onClick={() => {
                !isFetchingReport && (setTabIndex(index), setOpenDetail(false))
                handlerList({ ...state, taskType: item.type })
              }}
            >
              <MDTypography
                sx={({ breakpoints }) => ({
                  ...noteTypography(breakpoints),
                  lineHeight: 1.25,
                  ...(isFetchingReport && { color: "#999999" }),
                  textAlign: "center",
                })}
              >
                {item.label}
              </MDTypography>
            </Grid>
          ))}
        </Grid>
      </MDBox>

      {/* Body */}
      <MDBox width="100%">
        <Grid container width="100%" columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={isOpenDetail && !mobileMatches ? 4 : 12}>
            <MDBox
              sx={({ breakpoints, functions: { pxToRem } }) => ({
                background: "#EDF2F7",
                padding: pxToRem(24),
                borderRadius: pxToRem(15),
                [breakpoints.down(1600)]: {
                  padding: pxToRem(16),
                  borderRadius: pxToRem(8),
                },
              })}
            >
              <MDTypography
                sx={({ breakpoints }) => ({
                  ...titleTypography(breakpoints),
                  lineHeight: 1.625,
                  letterSpacing: "-0.8px",
                  marginBottom: "20px",
                })}
              >
                Task list
              </MDTypography>
              <MDBox
                ref={contentRef}
                display="flex"
                rowGap={2.5}
                sx={({ breakpoints, functions: { pxToRem } }) => ({
                  flexDirection: "column",
                  maxHeight: 600,
                  overflowY: "scroll",
                  "&::-webkit-scrollbar": {
                    display: isScrolling ? "block" : "none",
                    width: pxToRem(6),
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#8898aa",
                    borderRadius: pxToRem(3),
                  },
                  [breakpoints.down(1600)]: { maxHeight: 400 },
                  [breakpoints.down(768)]: {
                    flexDirection: "row",
                    overflow: "scroll",
                    gap: 2.5,
                    height: "fit-content",
                    "&::-webkit-scrollbar": { display: "none !important" },
                  },
                })}
              >
                {renderList()}
              </MDBox>
            </MDBox>

            {/* Pagination */}
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                pt: 2,
                gap: 1,
              }}
            >
              <MDBox
                sx={(theme) =>
                  pagingItemStyle(theme, {
                    active: false,
                    isArrow: true,
                    disable: currentPage === 0,
                  })
                }
                onClick={() =>
                  currentPage > 0 &&
                  handlerList({ ...state, page: state.page - 1 })
                }
              >
                <ChevronLeft sx={{ color: "#8392AB" }} />
              </MDBox>

              {filteredPages.map((item, index) => (
                <MDBox
                  key={index}
                  sx={(theme) =>
                    pagingItemStyle(theme, { active: item === state.page + 1 })
                  }
                  onClick={() => {
                    handlerList({ ...state, page: item - 1 })
                  }}
                >
                  {item}
                </MDBox>
              ))}

              <MDBox
                sx={(theme) =>
                  pagingItemStyle(theme, {
                    active: false,
                    isArrow: true,
                    disable: currentPage >= totalPage - 1,
                  })
                }
                onClick={() =>
                  currentPage < totalPage - 1 &&
                  handlerList({ ...state, page: state.page + 1 })
                }
              >
                <ChevronRight sx={{ color: "#8392AB" }} />
              </MDBox>
            </MDBox>
          </Grid>

          {isOpenDetail && (
            <TodoDetail
              data={dataDetail}
              type={"LXO"}
              onClose={() => {
                setOpenDetail(false)
                setSearchParams({})
              }}
              refetch={refetch}
            />
          )}
        </Grid>
      </MDBox>
    </MDBox>
  )
}

export default TodoListLXOMyTask
